import { render, staticRenderFns } from "./confirmRefundNew.vue?vue&type=template&id=96da353c&scoped=true&"
import script from "./confirmRefundNew.vue?vue&type=script&lang=js&"
export * from "./confirmRefundNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96da353c",
  null
  
)

export default component.exports